import { render, staticRenderFns } from "./OpenBook.vue?vue&type=template&id=3647cbe8"
import script from "./OpenBook.vue?vue&type=script&lang=js"
export * from "./OpenBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports